import { ParallelGateway, BpmnModelHelper, FlowNodeState } from "@edp-pmf/bpmn-model";
import { ParallelGatewayCell } from "@edp-pmf/grapheditor";
import { WfConstants } from "../WfConstants";

/**
 * 并行事件节点，增加状态图片信息
 */
export class WfParallelGatewayCell extends ParallelGatewayCell {
    imgUrls = {
        [FlowNodeState.Default]: WfConstants.IMAGE_PATH + "/ParallelGateway.png",
        [FlowNodeState.Selected]: WfConstants.IMAGE_PATH + "/ParallelGateway_select.svg",
    };

    createFlowElement(flowElt?: ParallelGateway) {
        const flowNode = super.createFlowElement(flowElt) as ParallelGateway;
        flowNode.Id = "ParallelGateway" + BpmnModelHelper.GenerateElementId();

        return flowNode;
    }
}